 // For Child Pages - Media/Text Blocks 

(function($){

	 $('.media-text-group .wp-block-media-text:even').addClass("has-media-on-the-right");
	 
})(jQuery);
